import { BehaviorSubject } from 'rxjs';
import { OnInit, Input } from '@angular/core';
import { UISearchZoneModel } from 'e5core-angular-services';
import { SearchFormModel } from '../../../models/search-form.model';

export class E5coreUiSearchFormBaseComponent implements OnInit {

  @Input() searchForm$: BehaviorSubject<SearchFormModel> ;
  @Input() zones: UISearchZoneModel[] ;
  @Input() zoneTemplateId: string ;

  zoneId: Number[] = [] ;

  ngOnInit() {
  }
}
